import React from 'react';
import { color as palette } from "@/constants/palette";

function CheckedBox() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
    >
      <rect
        x='0.832031'
        y='1.3335'
        width='18.3333'
        height='18.3333'
        rx='4'
        fill={palette.primary}
      />
      <path
        d='M5 9.7657L8.53836 13.4167L15 6.75'
        stroke='white'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default CheckedBox;
